//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/check_box'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/load_indicator'

//#endregion

import { FieldModel, EntityModel } from '../../api/api.models'
import { Details } from '../../common/common.details'

//#region Helepr Imports

import { DataProviderListResult } from '../../../data-provider'
import { CommonHelper, } from '../../../helpers/common-helper'
import { IUserSession } from '../../../helpers/user-session'
import { Dictionary, KeyType, TypeHelper, LogHelper } from '../../../helpers'

//#endregion

//#region Service Imports

import { LOCATION_SERVICE_NAME, LocationService } from '../../../services/location'
import { DATA_TYPE_FORMAT_SERVICE_NAME, DataTypeFormatService, DataTypeFormatter } from '../../../services/data-type'
import { REFERENCE_TYPE_SERVICE_NAME, ReferenceTypeService } from '../../../services/reference-type'
import { SYSTEM_SERVICE_NAME, $SCOPE_SERVICE_NAME, $ELEMENT_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $Q_SERVICE_NAME, SystemService } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'

//#endregion

//#region Model Imports

import { Enums } from '../../../models/common/enums'
import { IReferenceType, IOpObject } from '../../../models/util/interfaces'
import { OpLocation, OpDataTypeInGroup, OpView, OpViewColumn } from '../../../models/core'

//#endregion

//#region Asset Imports

import './details-parameters.scss'
import * as TEMPLATE from './details-parameters.tpl.html'

//#endregion


// Options

export type DetailsParametersOptions = {
    dataTypes: OpDataTypeInGroup[]
    referenceObject: IReferenceType & IOpObject
    referenceType: Enums.ReferenceType
    indexNbr?: number
    useDynamicValues?: boolean

    onDataLoaded?: () => void
}

// Options End


interface DetailsParametersScope extends ng.IScope {
    fields: any[]
    items: any[]

    modelId: number
    popupFor: string
    parseDate(value: any): string
    referenceType: Enums.ReferenceType

    CommonHelper: CommonHelper
    DistributorDetails(field: FieldModel)
    DeviceDetails(field: FieldModel)
    MeterDetails(field: FieldModel)
    RouteDetails(field: FieldModel)
    UserDetails(field: FieldModel)
    LocationDetails(field: FieldModel)

    scrollViewOptions: DevExpress.ui.dxScrollViewOptions

    detailsPopupId: number
    showParams: boolean

    addDistributorDetails: boolean
    addDeviceDetails: boolean
    addMeterDetails: boolean
    addRouteDetails: boolean
    addUserDetails: boolean

    isLoaded: boolean

    getReferenceValue(field: FieldModel)
}

export class DetailsParametersDirective implements ng.IDirective {

    //#region Consts

    private get LOG_PREFIX(): string { return '[SIMAX.Common.DetailsParameters]' }

    //#endregion


    // Members

    private view: OpView
    private locationTypeDictionary: Dictionary<Enums.LocationType>
    private dataTypeFormatter: DataTypeFormatter

    // Members End

    constructor() { }

    restrict = 'E'
    scope = {
        fields: '=?',
        modelId: '=?',
        popupFor: '=?',
        options: '=?'
    }
    template = TEMPLATE

    controller =
        [
            $SCOPE_SERVICE_NAME,
            $Q_SERVICE_NAME,
            $ELEMENT_SERVICE_NAME,
            $TIMEOUT_SERVICE_NAME,
            DATA_TYPE_FORMAT_SERVICE_NAME,
            REFERENCE_TYPE_SERVICE_NAME,
            LOCATION_SERVICE_NAME,
            SYSTEM_SERVICE_NAME,
            USER_SESSION_SERVICE_NAME, (
                $scope: DetailsParametersScope,
                $q: ng.IQService,
                $element: JQuery,
                $timeout: ng.ITimeoutService,
                dataTypeFormatService: DataTypeFormatService,
                referenceTypeSerivce: ReferenceTypeService,
                locationService: LocationService,
                systemService: SystemService,
                userSession: IUserSession
            ) => {
                $scope.CommonHelper = CommonHelper
                $scope.detailsPopupId = new Date().getTime()

                this.locationTypeDictionary = new Dictionary<Enums.LocationType>(null, KeyType.Number)

                $scope.$watch('modelId', val => {
                    $scope.showParams = false
                })

                $scope.$watch('fields', (val: FieldModel[]) => {
                    if (!val) {
                        return
                    }

                    $scope.showParams = true
                    $scope.items = TypeHelper.clone(val, true)

                    const promises = []
                    const fieldIdDataTypes: Enums.DataType[] = _.map($scope.items, (field: FieldModel) => {
                        return field.idDataType
                    })

                    dataTypeFormatService
                        .getDataTypeFormatter(fieldIdDataTypes)
                        .then((dataTypeFormatter: DataTypeFormatter) => {
                            this.dataTypeFormatter = dataTypeFormatter


                            $timeout(() => {
                                var height = 0
                                $element.find('.field').each((i, e) => {
                                    height += angular.element(e).outerHeight()
                                })
                                height += $element.find('.extra-space').outerHeight(true) + 10
                                var parentHeight = $element.parent().outerHeight(true) + 10
                                if (parentHeight - height > 0) $element.height(height)
                            })

                            $scope.isLoaded = true

                            _.forEach($scope.items, field => {
                                if (field.referenceTypeId && field.value && field.typeId == Enums.DataTypeClass.Integer) {
                                    $scope.isLoaded = false

                                    if (!this.view || this.view.getPrimaryKeyColumn().idDataType !== field.idDataType) {
                                        promises.push($scope.getReferenceValue(field))
                                    }
                                }

                                if (field.typeId != Enums.DataTypeClass.Boolean) {
                                    field.value = this.dataTypeFormatter.formatDisplayValue(field.value, {
                                        idDataType: field.idDataType,
                                        idDataTypeClass: field.typeId,
                                    })
                                }
                            })

                            $q.all(promises).then(() => {
                                $scope.isLoaded = true

                                if ($scope.options != null && _.isFunction($scope.options.onDataLoaded)) {
                                    $scope.options.onDataLoaded()
                                }
                            })
                        })
                })

                $scope.$watch('options', (options: DetailsParametersOptions) => {
                    if (!options) {
                        return
                    }

                    if (options.referenceObject != null && options.dataTypes != null) {
                        this.view = userSession.getDataProvider().View.getActiveViewLocal(options.referenceType);
                        const hiddenColumns: OpViewColumn[] = this.view.columns.filter((column: OpViewColumn) => column.isHidden)

                        $scope.modelId = options.referenceObject.idObject

                        if (options.useDynamicValues) {
                            $scope.fields = Details.filterDynamicValues(options.referenceObject, options.dataTypes, options.indexNbr, hiddenColumns)
                        }
                        else {
                            $scope.fields = Details.filterOpObjectFields(options.referenceObject, options.dataTypes, options.indexNbr)
                        }
                    } else {
                        $scope.fields = []
                    }
                })

                $scope.scrollViewOptions = {
                    height: '100%'
                }

                $scope.DeviceDetails = (field) => {
                    systemService.openDetails({
                        moduleName: Enums.SimaxModuleName.Device,
                        referenceObjectId: field.valueReferenceId || field.value,
                    })
                }
                $scope.DistributorDetails = (field) => {
                    systemService.openDetails({
                        moduleName: Enums.SimaxModuleName.Distributor,
                        referenceObjectId: field.valueReferenceId || field.value,
                    })
                }
                $scope.MeterDetails = (field) => {
                    systemService.openDetails({
                        moduleName: Enums.SimaxModuleName.Meter,
                        referenceObjectId: field.valueReferenceId || field.value,
                    })
                }
                $scope.RouteDetails = (field) => {
                    systemService.openDetails({
                        moduleName: Enums.SimaxModuleName.Route,
                        referenceObjectId: field.valueReferenceId || field.value,
                    })
                }
                $scope.UserDetails = (field) => {
                    systemService.openDetails({
                        moduleName: Enums.SimaxModuleName.Operator,
                        referenceObjectId: field.valueReferenceId || field.value,
                    })
                }
                $scope.LocationDetails = (field) => {
                    const locationType: Enums.LocationType = this.locationTypeDictionary.tryGetTypedValue<Enums.LocationType>(field.valueReferenceId || field.value)

                    systemService.openDetails({
                        moduleName: locationType === Enums.LocationType.DepositoryLocation ? Enums.SimaxModuleName.Depository : Enums.SimaxModuleName.Location,
                        referenceObjectId: field.valueReferenceId || field.value,
                    })
                }

                $scope.getReferenceValue = (field: FieldModel) => {
                    var request: EntityModel = new EntityModel()
                    request.referenceId = field.referenceTypeId
                    request.id = field.value

                    return getReferenceObject(field.referenceTypeId, field.value).then((referenceObject: IReferenceType) => {
                        if (referenceObject != null) {
                            field.value = referenceObject.toString()

                            if (field.referenceTypeId === Enums.ReferenceType.IdLocation) {
                                return locationService
                                    .getLocationType(referenceObject as OpLocation)
                                    .then((locationType: Enums.LocationType) => {
                                        this.locationTypeDictionary.addOrUpdate(referenceObject.getReferenceKey(), locationType)
                                    })
                            }
                        }
                    })
                }

                const getReferenceObject = (idReferenceType: Enums.ReferenceType, idReferenceObject: number): JQueryPromise<IReferenceType> => {
                    return referenceTypeSerivce
                        .getReferenceObjects(idReferenceType, {
                            filterOptions: {
                                columns: null,
                                customWhereClause: "",
                            },
                            pagingOptions: {
                                pageNumber: 1,
                                pageSize: 1,
                            },
                            referenceValues: [idReferenceObject]
                        })
                        .then((result: DataProviderListResult<IReferenceType>) => {
                            if (result != null) {
                                return _.first(result.objects) || null
                            }

                            return null
                        })
                        .fail((error: any) => {
                            LogHelper.warn(this.LOG_PREFIX, `Unable to load reference object for idReferenceType ${idReferenceType} and idReferenceObject ${idReferenceObject}`, error)

                            return null
                        })
                }
            }]

    transclude = true

}
